module.exports = __webpack_public_path__ + "static/media/facebook (3).a7104496.png";